
  import {Component, Vue} from "vue-property-decorator";
  import LogoTitleBlock from "@/modules/Auth/components/LogoTitleBlock.vue";

  @Component({
    components: {
      LogoTitleBlock,
    },
  })
  export default class PagePaymentResult extends Vue {
    status = 'success';
    typeContent = 'payment';
    resultData = {
      payment: {
        success: {
          success: true,
          title: 'Оплата прошла успешно',
          text: 'Ваша оплата прошла успешно.<br>Можете закрыть это окно.',
        },
        error: {
          success: false,
          title: 'Произошла ошибка',
          text: `
          Что-то пошло не так.<br>
          Проверьте данные карты и баланс на ней.<br>
          Закройте это окно и попробуйте повторить попытку.
        `,
        },
      },
      saveCard: {
        success: {
          success: true,
          title: 'Успешно',
          text: 'Данные отправлены.<br>Список карт обновиться в личном кабинете через какое-то время.<br>Можете закрыть это окно.',
        },
        error: {
          success: false,
          title: 'Произошла ошибка',
          text: `
          Что-то пошло не так.<br>
          Проверьте данные карты и баланс на ней.<br>
          Закройте это окно и попробуйте повторить попытку.
        `,
        },
      },
      timeOut: {
        error: {
          success: false,
          title: 'Время на оплату вышло',
          text: `Закройте это окно и попробуйте повторить попытку.`,
        },
      },
    };

    get content() { return this.resultData[this.typeContent][this.status]; }

    async created() {
      let { status, type } = this.$route.query;
      if (status) this.status = status.toString();
      if (type) this.typeContent = type.toString();
      await this.$store.dispatch('initialized');
    }

    closeAction() {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({
          type: 'PAYMENT_RESULT_CLOSE',
          data: {
            typeContent: this.typeContent,
            status: this.status,
          },
        }, window.location.origin);
      }
    }

  }
